import Vuex from "vuex";

const aiStore = new Vuex.Store({
  state: {
    chatData: [],
    sessionId: ''
  },
  mutations: {
    sendChat(state, data) {
      state.chatData.push(data);
    },
  },
  getters: {

  },
});

export { aiStore };
